import { render } from "./LayoutSidebar.vue?vue&type=template&id=3507755e&scoped=true"
import script from "./LayoutSidebar.vue?vue&type=script&lang=js"
export * from "./LayoutSidebar.vue?vue&type=script&lang=js"

import "./LayoutSidebar.vue?vue&type=style&index=0&id=3507755e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3507755e"]])

export default __exports__